export default "__VITE_ASSET__CjjDZsOT__"